/* unplugin-vue-components disabled */import script from "./PriceBlock2.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceBlock2.vue?vue&type=script&lang=ts&setup=true"

import "./PriceBlock2.vue?vue&type=style&index=0&id=acbb4dd0&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acbb4dd0"]])

export default __exports__